import { render, staticRenderFns } from "./CommonSortConjunctionPrimary.vue?vue&type=template&id=e98fb564&scoped=true"
import script from "./CommonSortConjunctionPrimary.vue?vue&type=script&lang=js"
export * from "./CommonSortConjunctionPrimary.vue?vue&type=script&lang=js"
import style0 from "./CommonSortConjunctionPrimary.vue?vue&type=style&index=0&id=e98fb564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98fb564",
  null
  
)

export default component.exports